<template>
  <div>
    <div
      v-if="availableItems.length"
      class="mb-3 flex items-center justify-between ps-5"
    >
      <span class="text-base">{{ $t('titles.Available') }}</span>
      <span class="text-gray-500 dark:text-neutral-300">
        {{ $t('titles.count.short', { count: availableItems.length }) }}
      </span>
    </div>
    <div v-else class="my-4 text-center">
      {{ $t('titles.No available premises') }}
    </div>

    <div v-if="availableItems.length" class="mb-4">
      <InstanceCard
        class="mb-2"
        :class="{
          highlited: highlighted == instance.id,
        }"
        v-for="instance in availableItems"
        :key="instance.id"
        @mouseover="handleInstanceMouseOver(instance.id)"
        @mouseleave="handleInstanceMouseLeave(instance.id)"
        view="list"
        :instance="instance"
        :minified="true"
      />
    </div>
    <div v-if="notAvailableItems.length" class="mb-3 mt-8 ps-5">
      {{ $t('titles.Not available') }}
    </div>
    <div class="mb-4">
      <InstanceCard
        class="mb-2"
        :class="{
          highlited: highlighted == instance.id,
        }"
        v-for="instance in notAvailableItems"
        :key="instance.id"
        @mouseover="handleInstanceMouseOver(instance.id)"
        @mouseleave="handleInstanceMouseLeave(instance.id)"
        view="list"
        :instance="instance"
        :minified="true"
      />
    </div>
  </div>
</template>

<script>
import InstanceCard from '@/components/cards/InstanceCard';

export default {
  name: 'InstancesList',
  data() {
    return {
      selectedShape: null,
    };
  },
  components: {
    InstanceCard,
  },
  props: {
    instances: {
      type: Array,
      required: true,
    },
    highlighted: {
      type: [Number, String, null],
      default: null,
    },
  },

  computed: {
    availableItems() {
      return this.instances.filter((instance) => instance?.status.type === 1);
    },
    notAvailableItems() {
      return this.instances.filter((instance) => instance?.status.type !== 1);
    },
  },
  methods: {
    handleInstanceMouseOver(instanceId) {
      this.$emit('instanceOver', instanceId);
    },
    handleInstanceMouseLeave(instanceId) {
      this.$emit('instanceLeave', instanceId);
    },
  },
};
</script>
